module.exports = __webpack_public_path__ + "Roboto-Regular.30799efa5bf74129468a.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/font/roboto/Roboto-Regular.eot
// module id = ../../../../../font/roboto/Roboto-Regular.eot
// module chunks = styles